var map = {
	"./Bankhaus-grau.png": 1058,
	"./Bankhaus.png": 7243,
	"./Ecoroll-grau.png": 230,
	"./Ecoroll.png": 1262,
	"./Freyler-grau.png": 1041,
	"./Freyler.png": 4290,
	"./Innius-grau.png": 6907,
	"./Innius.png": 2989,
	"./QiTec-grau.png": 8350,
	"./QiTec.png": 2442,
	"./Suedvers-grau.png": 8707,
	"./Suedvers.png": 3550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7656;